/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";

const initialState: { allowedPermission: {}; activeFeature: {} } = {
  allowedPermission: {},
  activeFeature: {}
};

const PermissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    postAllowedPermission: (state, action) => {
      state.allowedPermission = action.payload;
    },
    postActiveFeature: (state, action) => {
      state.activeFeature = action.payload;
    }
  }
});

export const { postAllowedPermission, postActiveFeature } = PermissionSlice.actions;
export default PermissionSlice.reducer;

export const getAllowedPermission = (state: RootState) => state.permission.allowedPermission;
export const getActiveFeature = (state: RootState) => state.permission.activeFeature;
